activ.directive("homeFooter", function(){

    return {
        restrict: "E",
        template: "<p class=\"footer\">&copy; {{ $parent.theYear }} activDS ({{version}})</p>",
        link: function($scope, element, attr) {
            $scope.version = version;
        }
    }
});